module.exports = __webpack_public_path__ + "static/media/logo2.8cb193d3.svg";